<div [class]="row ? 'flex-row flex-align-center px-gap-' + gap : 'flex-col'">
  <ng-container *ngIf="circle; else block">
    <span *ngFor="let c of _count" class="skeleton circle" [class.dark]="darkTheme"></span>
  </ng-container>

  <ng-template #block>
    <span
      *ngFor="let c of _count; let i = index"
      class="skeleton"
      [class.dark]="darkTheme"
      [ngStyle]="{ width: _widths[i], height: _height }"
    ></span>
  </ng-template>
</div>
